import React, { useState } from 'react'
import { Tooltip, IconButton } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { CopyContant } from '@/utils/copyContant'

export interface CopyTooltipProps {
  text: string
  placement?: any
  ariaLabel?: string
  className?: string
  showText?: boolean
}

const CopyTooltip: React.FC<CopyTooltipProps> = ({
  text,
  placement = 'right',
  ariaLabel = 'Copy to clipboard',
  className,
  showText = true,
}) => {
  const [tooltipMessage, setTooltipMessage] = useState('Copy')
  const [showTooltip, setShowTooltip] = useState(false)

  const handleCopy = async () => {
    await CopyContant(text)
    setTooltipMessage('Copied')
    setShowTooltip(true)
    setTimeout(() => {
      setTooltipMessage('Copy')
      setShowTooltip(false)
    }, 1000)
  }

  return (
    <>
      {showText && <em>{text}</em>}
      {showText && '\u00A0'}
      <Tooltip
        title={tooltipMessage}
        placement={placement}
        arrow
        open={showTooltip}
        onOpen={() => setShowTooltip(true)}
        onClose={() => setShowTooltip(false)}
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#333',
              color: '#fff',
              padding: '8px 12px',
              fontSize: '12px',
              '& .MuiTooltip-arrow': {
                color: '#333',
              },
            },
          },
        }}
      >
        <IconButton
          onClick={handleCopy}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() =>
            !tooltipMessage.includes('Copied') && setShowTooltip(false)
          }
          aria-label={ariaLabel}
          className={className}
          sx={{ padding: '0 6px' }}
        >
          <ContentCopyIcon
            fontSize="small"
            sx={{ color: '#666', cursor: 'pointer' }}
          />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default CopyTooltip
